import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../core/services/authentication/authentication.service';
import { Router } from '@angular/router';
import { LoaderService } from '../core/services/loader/loader.service';
import { OidcClientService } from '../core/services/oidc-client-ts/oidc-client.service';

@Component({
    selector: 'app-signout-callback',
    templateUrl: './signout-callback.component.html',
    styleUrls: ['./signout-callback.component.scss'],
    standalone: false
})
export class SignoutCallbackComponent implements OnInit {

  constructor(
    public router: Router,
    private loaderService: LoaderService,
    private oidcClientService: OidcClientService,
    private authService: AuthenticationService,
  ) { }

  ngOnInit() {
    if (this.router.url === '/signout-callback') {
      if (this.authService.isUserActiveInPC) {
        // redirect to new logout page
        this.router.navigate(["/logout"]);
      }
      else {
        this.router.navigateByUrl("/unauthorized");
        this.loaderService.hide();
      }
      this.authService.clearIsUserActiveInPC();
    }
  }
}
